module.exports = __webpack_public_path__ + "8cfb80d29cc646e30bc18eee20860d2f.png";